import { getAuthLocalStorageKeys } from './getAuthLocalStorageKeys.mjs';

export function clearAuthLocalStorage(cognitoUserId, cognitoClientId) {
  const { accessTokenKey, idTokenKey, refreshTokenKey, userDataKey, clockDriftKey, lastUserKey } =
    getAuthLocalStorageKeys(cognitoUserId, cognitoClientId);

  window.localStorage.removeItem('id_token');
  window.localStorage.removeItem('access_token');
  window.localStorage.removeItem('refresh_token');
  window.localStorage.removeItem(accessTokenKey);
  window.localStorage.removeItem(idTokenKey);
  window.localStorage.removeItem(refreshTokenKey);
  window.localStorage.removeItem(userDataKey);
  window.localStorage.removeItem('amplify-signin-with-hostedUI');
  window.localStorage.removeItem(clockDriftKey);
  window.localStorage.removeItem(lastUserKey);
}
